import * as Types from '../../../graphql';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type MainClientExpertInfoQueryVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
}>;


export type MainClientExpertInfoQuery = { __typename?: 'Query', accounts?: { __typename?: 'accounts', mainClientExpertUsingGET?: { __typename?: 'accounts_ExpertProfileRepresentation', expertData?: { __typename?: 'accounts_ExpertProfileMinimalRepresentation', externalId?: string | null, acquireDate?: number | null, autoDescription?: string | null, ceccarCode?: string | null, partnerEid?: string | null } | null, person?: { __typename?: 'accounts_PersonRepresentation', externalId?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, fullName?: string | null } | null } | null } | null };

export type ClientContractDocumentQueryVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
}>;


export type ClientContractDocumentQuery = { __typename?: 'Query', accounts?: { __typename?: 'accounts', GetClientUsingGET?: { __typename?: 'accounts_ClientRepresentation', companyName?: string | null, signedContractDocumentEid?: string | null } | null, getClientRegistrationDataDiyUsingGET?: { __typename?: 'accounts_ClientRegistrationDiyDataRepresenation', generatedContractDocumentEid?: string | null } | null } | null };

export type ClientFiscalInfoSummaryForMonthQueryVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
  forMonth?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type ClientFiscalInfoSummaryForMonthQuery = { __typename?: 'Query', accounts?: { __typename?: 'accounts', getClientFiscalInfoSummaryForMonthUsingGET?: { __typename?: 'accounts_ClientFiscalInfoSummaryRepresentation', isVATPayer?: boolean | null } | null } | null };

export type GetKeezSubscriptionInvoicesQueryVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
}>;


export type GetKeezSubscriptionInvoicesQuery = { __typename?: 'Query', accounts?: { __typename?: 'accounts', getKeezSubscriptionInvoicesUsingGET?: { __typename?: 'accounts_InvoiceSubscriptionListRepresentation', data?: Array<{ __typename?: 'accounts_InvoiceSubscriptionRepresentation', externalId?: string | null, documentDate?: number | null, dueDate?: number | null, invoiceNo?: number | null, invoiceSerial?: string | null, invoiceSerialNo?: string | null, currencyCode?: string | null, referenceCurrencyCode?: string | null, netAmount?: number | null, vatAmount?: number | null, grossAmount?: number | null, remainingAmount?: number | null }> | null, totals?: { __typename?: 'accounts_InvoiceTotalsRepresentation', totalsInRON?: { __typename?: 'accounts_InvoiceTotalsData', totalRemainingAmount?: number | null } | null } | null } | null } | null };

export type GetKeezSubscriptionInvoiceQueryVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
  externalId: Types.Scalars['String'];
}>;


export type GetKeezSubscriptionInvoiceQuery = { __typename?: 'Query', accounts?: { __typename?: 'accounts', getKeezSubscriptionInvoiceUsingGET?: { __typename?: 'accounts_InvoiceRepresentation', externalId?: string | null, grossAmount?: number | null, invoiceDetails?: Array<{ __typename?: 'accounts_InvoiceDetailRepresentation', itemExternalId?: string | null, itemCode?: string | null, itemName?: string | null, itemDescription?: string | null, grossAmount?: number | null }> | null } | null } | null };

export type GetSubscriptionInvoiceHistoryForInvoiceQueryVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
  invoiceEid: Types.Scalars['String'];
}>;


export type GetSubscriptionInvoiceHistoryForInvoiceQuery = { __typename?: 'Query', billing?: { __typename?: 'billing', getSubscriptionInvoiceHistoryForInvoiceUsingGET?: { __typename?: 'billing_SubscriptionInvoiceHistoryRepresentation', externalId?: string | null, basePriceWithDelta?: number | null, computedPrice?: number | null, computedPriceWithoutPromotion?: number | null, docsNum?: number | null, docsNumExtra?: number | null, docsNumIncluded?: number | null, docsNumPackagesExtra?: number | null, docsPriceExtra?: number | null, empsNum?: number | null, empsNumExtra?: number | null, empsNumIncluded?: number | null, empsNumPackagesExtra?: number | null, empsPriceExtra?: number | null, forSubscriptionMonth?: number | null, impsNum?: number | null, impsNumExtra?: number | null, impsNumIncluded?: number | null, impsNumPackagesExtra?: number | null, impsPriceExtra?: number | null, vatDelta?: number | null, totalPriceExtra?: number | null, keezInvoice?: { __typename?: 'billing_KeezInvoiceRepresentation', invoiceEid?: string | null, invoiceNumber?: string | null, itemDescription?: string | null, itemComment?: string | null, dateCreated?: number | null, initialValue?: number | null, remainingValue?: number | null } | null, promotionCode?: { __typename?: 'billing_PromotionCodeRepresentation', code?: string | null, promotionDefinition?: { __typename?: 'billing_PromotionDefinitionRepresentation', description?: string | null, discount?: number | null } | null } | null } | null } | null };

export type GetClientDataQueryVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
}>;


export type GetClientDataQuery = { __typename?: 'Query', accounts?: { __typename?: 'accounts', GetClientUsingGET?: { __typename?: 'accounts_ClientRepresentation', externalId?: string | null, companyName?: string | null, fiscalNumber?: string | null, registrationNumber?: string | null } | null, getSitesUsingGET?: Array<{ __typename?: 'accounts_SiteRep', externalId?: string | null, countyName?: string | null, cityName?: string | null, addressDetails?: string | null, isActive?: boolean | null, siteTypeCode?: string | null }> | null } | null };

export type GetCreditCardsQueryVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
}>;


export type GetCreditCardsQuery = { __typename?: 'Query', billing?: { __typename?: 'billing', getCreditCardsUsingGET?: Array<{ __typename?: 'billing_BillingCreditCardRepresentation', externalId?: string | null, cardNumber?: string | null, expirationDate?: string | null, isActive?: boolean | null, isRemoved?: boolean | null, firstName?: string | null, lastName?: string | null }> | null } | null };

export type SetActiveCardMutationVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
  creditCardEid: Types.Scalars['String'];
}>;


export type SetActiveCardMutation = { __typename?: 'Mutation', billing?: { __typename?: 'billing_mutation', setCreditCardStatusActiveUsingPUT?: { __typename?: 'billing_SuccessResponse', Message?: string | null } | null } | null };

export type DeleteCardMutationVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
  cardEid: Types.Scalars['String'];
}>;


export type DeleteCardMutation = { __typename?: 'Mutation', billing?: { __typename?: 'billing_mutation', setCreditCardStatusRemovedUsingPUT?: { __typename?: 'billing_SuccessResponse', Message?: string | null } | null } | null };

export type PostUnifiedPaymentRequestMutationVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
  request: Types.Billing_UnifiedPaymentRequestRepresentationInput;
}>;


export type PostUnifiedPaymentRequestMutation = { __typename?: 'Mutation', billing?: { __typename?: 'billing_mutation', postUnifiedPaymentRequestUsingPOST?: { __typename?: 'billing_UnifiedPaymentResponsetRepresentation', requestType?: string | null, url?: string | null } | null } | null };

export type GetKeezSubscriptionSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetKeezSubscriptionSettingsQuery = { __typename?: 'Query', accounts?: { __typename?: 'accounts', getKeezSubscriptionSettingsUsingGET?: { __typename?: 'accounts_SubscriptionSettingsRepresentation', iban?: string | null } | null } | null };

export type GetClientDocumentsTotalStatisticsForContractQueryVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
}>;


export type GetClientDocumentsTotalStatisticsForContractQuery = { __typename?: 'Query', documents?: { __typename?: 'documents', GetClientDocumentsTotalStatisticsUsingGET?: { __typename?: 'documents_DocumentsCounterTotalRepresentation', contractNotExists?: number | null } | null } | null };

export type GetSubscriptionBadgesQueryVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
}>;


export type GetSubscriptionBadgesQuery = { __typename?: 'Query', billing?: { __typename?: 'billing', getSubscriptionBadgesUsingGET?: { __typename?: 'billing_SubscriptionBadgesRepresentation', hasExtraCost?: boolean | null, extraCostAmount?: number | null, hasUnpaidInvoice?: boolean | null, unpaidInvoiceAmount?: number | null } | null } | null };

export const MainClientExpertInfoDocument = gql`
    query mainClientExpertInfo($clientEid: String!) {
  accounts {
    mainClientExpertUsingGET(clientEid: $clientEid) {
      expertData {
        externalId
        acquireDate
        autoDescription
        ceccarCode
        partnerEid
      }
      person {
        externalId
        email
        firstName
        lastName
        phone
        fullName
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MainClientExpertInfoGQL extends Apollo.Query<MainClientExpertInfoQuery, MainClientExpertInfoQueryVariables> {
    document = MainClientExpertInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClientContractDocumentDocument = gql`
    query clientContractDocument($clientEid: String!) {
  accounts {
    GetClientUsingGET(clientEid: $clientEid) {
      companyName
      signedContractDocumentEid
    }
    getClientRegistrationDataDiyUsingGET(processEid: $clientEid) {
      generatedContractDocumentEid
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ClientContractDocumentGQL extends Apollo.Query<ClientContractDocumentQuery, ClientContractDocumentQueryVariables> {
    document = ClientContractDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClientFiscalInfoSummaryForMonthDocument = gql`
    query clientFiscalInfoSummaryForMonth($clientEid: String!, $forMonth: Int) {
  accounts {
    getClientFiscalInfoSummaryForMonthUsingGET(clientEid: $clientEid, forMonth: $forMonth) {
      isVATPayer
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ClientFiscalInfoSummaryForMonthGQL extends Apollo.Query<ClientFiscalInfoSummaryForMonthQuery, ClientFiscalInfoSummaryForMonthQueryVariables> {
    document = ClientFiscalInfoSummaryForMonthDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetKeezSubscriptionInvoicesDocument = gql`
    query getKeezSubscriptionInvoices($clientEid: String!) {
  accounts {
    getKeezSubscriptionInvoicesUsingGET(clientEid: $clientEid) {
      data {
        externalId
        documentDate
        dueDate
        invoiceNo
        invoiceSerial
        invoiceSerialNo
        currencyCode
        referenceCurrencyCode
        netAmount
        vatAmount
        grossAmount
        remainingAmount
      }
      totals {
        totalsInRON {
          totalRemainingAmount
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetKeezSubscriptionInvoicesGQL extends Apollo.Query<GetKeezSubscriptionInvoicesQuery, GetKeezSubscriptionInvoicesQueryVariables> {
    document = GetKeezSubscriptionInvoicesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetKeezSubscriptionInvoiceDocument = gql`
    query getKeezSubscriptionInvoice($clientEid: String!, $externalId: String!) {
  accounts {
    getKeezSubscriptionInvoiceUsingGET(clientEid: $clientEid, externalId: $externalId) {
      externalId
      grossAmount
      invoiceDetails {
        itemExternalId
        itemCode
        itemName
        itemDescription
        grossAmount
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetKeezSubscriptionInvoiceGQL extends Apollo.Query<GetKeezSubscriptionInvoiceQuery, GetKeezSubscriptionInvoiceQueryVariables> {
    document = GetKeezSubscriptionInvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSubscriptionInvoiceHistoryForInvoiceDocument = gql`
    query getSubscriptionInvoiceHistoryForInvoice($clientEid: String!, $invoiceEid: String!) {
  billing {
    getSubscriptionInvoiceHistoryForInvoiceUsingGET(clientEid: $clientEid, invoiceEid: $invoiceEid) {
      externalId
      basePriceWithDelta
      computedPrice
      computedPriceWithoutPromotion
      docsNum
      docsNumExtra
      docsNumIncluded
      docsNumPackagesExtra
      docsPriceExtra
      empsNum
      empsNumExtra
      empsNumIncluded
      empsNumPackagesExtra
      empsPriceExtra
      forSubscriptionMonth
      impsNum
      impsNumExtra
      impsNumIncluded
      impsNumPackagesExtra
      impsPriceExtra
      vatDelta
      totalPriceExtra
      keezInvoice {
        invoiceEid
        invoiceNumber
        itemDescription
        itemComment
        dateCreated
        initialValue
        remainingValue
      }
      promotionCode {
        code
        promotionDefinition {
          description
          discount
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSubscriptionInvoiceHistoryForInvoiceGQL extends Apollo.Query<GetSubscriptionInvoiceHistoryForInvoiceQuery, GetSubscriptionInvoiceHistoryForInvoiceQueryVariables> {
    document = GetSubscriptionInvoiceHistoryForInvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetClientDataDocument = gql`
    query getClientData($clientEid: String!) {
  accounts {
    GetClientUsingGET(clientEid: $clientEid) {
      externalId
      companyName
      fiscalNumber
      registrationNumber
    }
    getSitesUsingGET(clientExternalId: $clientEid) {
      externalId
      countyName
      cityName
      addressDetails
      isActive
      siteTypeCode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetClientDataGQL extends Apollo.Query<GetClientDataQuery, GetClientDataQueryVariables> {
    document = GetClientDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCreditCardsDocument = gql`
    query getCreditCards($clientEid: String!) {
  billing {
    getCreditCardsUsingGET(clientEid: $clientEid) {
      externalId
      cardNumber
      expirationDate
      isActive
      isRemoved
      firstName
      lastName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCreditCardsGQL extends Apollo.Query<GetCreditCardsQuery, GetCreditCardsQueryVariables> {
    document = GetCreditCardsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetActiveCardDocument = gql`
    mutation setActiveCard($clientEid: String!, $creditCardEid: String!) {
  billing {
    setCreditCardStatusActiveUsingPUT(clientEid: $clientEid, creditCardEid: $creditCardEid) {
      Message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetActiveCardGQL extends Apollo.Mutation<SetActiveCardMutation, SetActiveCardMutationVariables> {
    document = SetActiveCardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCardDocument = gql`
    mutation deleteCard($clientEid: String!, $cardEid: String!) {
  billing {
    setCreditCardStatusRemovedUsingPUT(clientEid: $clientEid, creditCardEid: $cardEid) {
      Message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCardGQL extends Apollo.Mutation<DeleteCardMutation, DeleteCardMutationVariables> {
    document = DeleteCardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PostUnifiedPaymentRequestDocument = gql`
    mutation postUnifiedPaymentRequest($clientEid: String!, $request: billing_UnifiedPaymentRequestRepresentationInput!) {
  billing {
    postUnifiedPaymentRequestUsingPOST(clientEid: $clientEid, request: $request) {
      requestType
      url
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PostUnifiedPaymentRequestGQL extends Apollo.Mutation<PostUnifiedPaymentRequestMutation, PostUnifiedPaymentRequestMutationVariables> {
    document = PostUnifiedPaymentRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetKeezSubscriptionSettingsDocument = gql`
    query getKeezSubscriptionSettings {
  accounts {
    getKeezSubscriptionSettingsUsingGET {
      iban
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetKeezSubscriptionSettingsGQL extends Apollo.Query<GetKeezSubscriptionSettingsQuery, GetKeezSubscriptionSettingsQueryVariables> {
    document = GetKeezSubscriptionSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetClientDocumentsTotalStatisticsForContractDocument = gql`
    query getClientDocumentsTotalStatisticsForContract($clientEid: String!) {
  documents {
    GetClientDocumentsTotalStatisticsUsingGET(clientEid: $clientEid) {
      contractNotExists
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetClientDocumentsTotalStatisticsForContractGQL extends Apollo.Query<GetClientDocumentsTotalStatisticsForContractQuery, GetClientDocumentsTotalStatisticsForContractQueryVariables> {
    document = GetClientDocumentsTotalStatisticsForContractDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSubscriptionBadgesDocument = gql`
    query getSubscriptionBadges($clientEid: String!) {
  billing {
    getSubscriptionBadgesUsingGET(clientEid: $clientEid) {
      hasExtraCost
      extraCostAmount
      hasUnpaidInvoice
      unpaidInvoiceAmount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSubscriptionBadgesGQL extends Apollo.Query<GetSubscriptionBadgesQuery, GetSubscriptionBadgesQueryVariables> {
    document = GetSubscriptionBadgesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }